import React, { useState } from "react"
import PropTypes from "prop-types"

import StarRating from "./StarRating"
import TrucksPanel from "./TrucksPanel"
import PricesPanel from "./PricesPanel"
import SubZonesModal from "./SubZonesModal"

/**
 * Formulario compartido por el alta y por la edición inline. Recibe el hook
 * `useAvailabilityForm` ya construido por quien lo usa.
 */
const AvailabilityForm = ({ form, regions, farm, onSaveZones }) => {
  const { state, error, events } = form
  const [isZonesOpen, setIsZonesOpen] = useState(false)
  const hasLocal = !!farm?.local_delivery

  return (
    <>
      {error && <div className="av-alert">{error}</div>}

      <div className="av-form-top">
        <div className="av-form-weight">
          <label className="av-label">Peso Mínimo</label>
          <input
            type="number"
            min="0"
            step="0.01"
            placeholder="0.00"
            className="av-field av-num"
            value={state.pesoMin}
            onChange={event => events.set("pesoMin", event.target.value)}
          />
        </div>
        <div className="av-form-weight">
          <label className="av-label">Peso Máximo</label>
          <input
            type="number"
            min="0"
            step="0.01"
            placeholder="0.00"
            className="av-field av-num"
            value={state.pesoMax}
            onChange={event => events.set("pesoMax", event.target.value)}
          />
        </div>

        <div className="av-form-spacer" />

        <StarRating
          label="Pigmento"
          value={state.pigmento}
          onChange={value => events.set("pigmento", value)}
        />
        <StarRating
          label="Calidad"
          value={state.calidad}
          onChange={value => events.set("calidad", value)}
        />
        <StarRating
          label="Salud del ave"
          value={state.salud}
          onChange={value => events.set("salud", value)}
        />

        <div className="av-form-notes">
          <label className="av-label">Observaciones</label>
          <textarea
            rows="2"
            placeholder="Notas sobre esta disponibilidad..."
            className="av-field"
            value={state.observaciones}
            onChange={event => events.set("observaciones", event.target.value)}
          />
        </div>
      </div>

      <div className="av-panels">
        <TrucksPanel
          trucks={state.trucks}
          onChange={events.setTruck}
          onAdd={events.addTruck}
          onRemove={events.removeTruck}
        />
        <PricesPanel
          regions={regions}
          prices={state.prices}
          hasLocal={hasLocal}
          localName={farm?.name || ""}
          onChange={events.setPrecio}
          onOpenZones={onSaveZones ? () => setIsZonesOpen(true) : null}
        />
      </div>

      {onSaveZones && (
        <SubZonesModal
          isOpen={isZonesOpen}
          regions={regions}
          prices={state.prices}
          hasLocal={hasLocal}
          onToggle={() => setIsZonesOpen(previo => !previo)}
          onSave={onSaveZones}
          onApplyPrices={events.aplicarPrecios}
        />
      )}
    </>
  )
}

AvailabilityForm.propTypes = {
  form: PropTypes.object.isRequired,
  regions: PropTypes.array.isRequired,
  farm: PropTypes.object,
  onSaveZones: PropTypes.func,
}

export default AvailabilityForm
